/*
 * Developed for G.J. Gardner Homes by Softeq Development Corporation
 * http://www.softeq.com
 */

import { arrayOf, date, DateFormat, enumeration, subentity } from '@gh/core-data';
import {
  EDocDetailsDto,
  EDocDto,
  EDocSignerDto,
  EDocSignerRole,
  EDocSigningStatus,
  EDocType,
} from './e-docs.dto';

export const EDocMapper = subentity<EDocDto>({
  addedDate: date(DateFormat.DateTime),
  status: enumeration(EDocSigningStatus),
  docType: enumeration(EDocType),
  signers: arrayOf(subentity<EDocSignerDto>({
    signedDate: date(DateFormat.DateTime),
    status: enumeration(EDocSigningStatus),
    type: enumeration(EDocSignerRole),
  })),
});

export const EDocDetailsMapper = subentity<EDocDetailsDto>({
  addedDate: date(DateFormat.Date),
  status: enumeration(EDocSigningStatus),
  docType: enumeration(EDocType),
  signers: arrayOf(subentity<EDocSignerDto>({
    signedDate: date(DateFormat.DateTime),
    status: enumeration(EDocSigningStatus),
    type: enumeration(EDocSignerRole),
  })),
});
